
import axios from 'axios';

import AppDispatcher from '../dispatcher/AppDispatcher';
import AppConstants from '../constants/AppConstants';
import Authentication from "../authentication/awsAuthentication";


import Config from './config.json';

var instance = axios.create({
    baseURL: Config[process.env.REACT_APP_ENVIRONMENT].host,
    headers: {
        'Content-Type' : 'application/json'
        //   'X-API-KEY' : Config.apikey
    }
});

class APIClass {
    newClient() {
        return instance ;
    }

    async secureGet(client, endpoint, body) {
        let session = await Authentication.getSession();
        client.defaults.headers.common['Authorization'] = await Authentication.getAuthorisation(session);
        console.log("[SecureGet] - ", endpoint) ;
        return await client.get(endpoint, body) ;
    }

    async securePut(client, endpoint, body) {
        let session = await Authentication.getSession();
        let token = await Authentication.getAuthorisation(session) ;
        client.defaults.headers.common['Authorization'] = token;
        return await client.put(endpoint, body) ;
    }

    async securePost(client, endpoint, body) {
        let session = await Authentication.getSession();
        let token = await Authentication.getAuthorisation(session) ;
        client.defaults.headers.common['Authorization'] = token;
        return await client.post(endpoint, body) ;
    }

    async secureDelete(client, endpoint, body) {
        let session = await Authentication.getSession();
        let token = await Authentication.getAuthorisation(session) ;
        client.defaults.headers.common['Authorization'] = token;
        return await client.delete(endpoint, body) ;
    }

    field(field,value,datatype,ignoreNull) {
        if (ignoreNull && !value) {
            return null ;
        }
        return {
                "name": field,
                "value": value,
                "datatype": datatype
            }
    }

    handle(query,handler) {
        query
        .then((r) => {
            console.log("[API] RESULT=", r);
            if (r.status && r.status === 200) {
                handler.success(r.data) ;
            }
            else {
                handler.failure(r.body);
            }
        })
        .catch((e) => {
            console.error("API Error: " + JSON.stringify(e));
            handler.failure(e);
        });
    }

    handleResponse(query,successAction,failAction) {
        query
        .then((r) => {
            console.log("[API] RESULT=", r);
            if (r.status && r.status === 200) {
                AppDispatcher.handleViewAction({
                    actionType  : successAction,
                    status      : AppConstants.OK_STATUS,
                    result      : r.data
                });
            }
            else if (r.status && r.status === 404) { // not found
                AppDispatcher.handleViewAction({
                    actionType  : successAction,
                    status      : AppConstants.OK_STATUS,
                    result      : r.data
                });
            }
            else {
                AppDispatcher.handleViewAction({
                    actionType  : failAction,
                    status      : AppConstants.ERROR_STATUS,
                    error       : r.body
                });
            }
        })
        .catch((e) => {
            console.error("API Error: " + JSON.stringify(e));
            AppDispatcher.handleViewAction({
                actionType  : failAction,
                status      : AppConstants.ERROR_STATUS,
                error       : e
            });
        });
    }

    syncCall(query,successAction,failAction) {
        query
        .then((r) => {
            console.log("[API] RESULT=", r);
            if (r.status && r.status === 200) {

                AppDispatcher.handleViewAction({
                    actionType  : successAction,
                    status      : AppConstants.OK_STATUS,
                    result      : r.data
                });
            }
            else if (r.status && r.status === 404) { // not found
                AppDispatcher.handleViewAction({
                    actionType  : successAction,
                    status      : AppConstants.OK_STATUS,
                    result      : r.data
                });
            }
            else {
                AppDispatcher.handleViewAction({
                    actionType  : failAction,
                    status      : AppConstants.ERROR_STATUS,
                    error       : r.body
                });
            }
        })
        .catch((e) => {
            console.error("API Error: " + JSON.stringify(e));
            AppDispatcher.handleViewAction({
                actionType  : failAction,
                status      : AppConstants.ERROR_STATUS,
                error       : e
            });
        });
    }

}

const API = new APIClass();
export default API;



// WEBPACK FOOTER //
// ./src/app/api/awsApi.js